import { Users, Database, Settings, Zap } from "lucide-react";
import { NichePage } from "./NichePageTemplate";

const sections = [
  {
    icon: Users,
    name: "Candidate Operations",
    items: [
      "Candidate database management", "Candidate pipelines",
      "Screening workflow coordination", "Interview scheduling", "Follow-up"
    ]
  },
  {
    icon: Settings,
    name: "Client Operations",
    items: [
      "Client database", "Lead management", "Job order tracking", "Follow-up"
    ]
  },
  {
    icon: Database,
    name: "CRM & Systems",
    items: [
      "CRM organization", "Pipeline management", "Database cleanup",
      "Workflow configuration"
    ]
  },
  {
    icon: Zap,
    name: "Automation",
    items: [
      "Candidate workflows", "Notifications", "Follow-up automation",
      "Task automation"
    ]
  }
];

export const RecruitmentPage = () => (
  <NichePage
    title="Recruitment & People Operations"
    subtitle="Structured workflows for candidate, client, and placement operations."
    sections={sections}
  />
);
